import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoading = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 72.134,
	height: 33.886,
	viewBox: "0 0 72.134 33.886",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_171",
		"data-name": "Group 171",
		transform: "translate(0)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				id: "Group_168",
				"data-name": "Group 168",
				transform: "translate(0)",
				opacity: 0,
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_327",
					"data-name": "Path 327",
					d: "M867.2,609.782H795.07V575.9H867.2Zm-71.613-.521h71.092V576.417H795.591Z",
					transform: "translate(-795.07 -575.896)",
					fill: "#040505"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_169",
				"data-name": "Group 169",
				transform: "translate(36.067 16.943)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_328",
					"data-name": "Path 328",
					d: "M864.3,608.416",
					transform: "translate(-864.296 -608.416)",
					fill: "none",
					stroke: "#040505",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 4
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_170",
				"data-name": "Group 170",
				transform: "translate(17.838 5.763)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_329",
						"data-name": "Path 329",
						d: "M857.782,618.63c-.062.052-.124.1-.185.148,2.929.234,12.344.1,12.439.1,1.149-.07,4.607-.547,6.228-1.875.833-.682,1.026-1.3.953-1.548-.011-.037-.029-.1-.184-.117-.375-.043-.806-.085-1.267-.131-2.66-.264-4.786-.511-5.939-1.082-.988-.49-2.854-1.663-4.566-2.776C863.083,613.563,859.358,617.307,857.782,618.63Z",
						transform: "translate(-842.857 -598.64)",
						fill: "none"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_330",
						"data-name": "Path 330",
						d: "M854.878,607.387l-.022.02.005,0C854.867,607.4,854.872,607.393,854.878,607.387Z",
						transform: "translate(-841.545 -596.742)",
						fill: "none"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_331",
						"data-name": "Path 331",
						d: "M858.354,612.509a4.505,4.505,0,0,1-1.914-.067,6.169,6.169,0,0,1-2.314-1.252.024.024,0,0,0-.023,0,7.239,7.239,0,0,0-.635,1.447,15.565,15.565,0,0,0-.763,3.45,1.048,1.048,0,0,1-.382.741l-.12.1c-.074.145-.2.434-.329.767a3.866,3.866,0,0,0,.327.223,6.438,6.438,0,0,0,1.5-.957C854.671,616.142,856.56,614.3,858.354,612.509Z",
						transform: "translate(-840.117 -598.562)",
						fill: "none"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_332",
						"data-name": "Path 332",
						d: "M868.6,597.308c0,.286.019.544.043.788a1.24,1.24,0,0,1,.7.2l.9.6.415-.426c.763-.862,2.872-3.643,3.078-5.729.106-1.072-.193-1.645-.42-1.769-.035-.019-.093-.049-.213.047-.3.236-.634.512-.994.807a41.924,41.924,0,0,1-3.5,2.674C868.6,595.565,868.6,596.623,868.6,597.308Z",
						transform: "translate(-848.126 -588.872)",
						fill: "none"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_333",
						"data-name": "Path 333",
						d: "M847.868,607.486a10.336,10.336,0,0,1,.773-1.8,2.1,2.1,0,0,1,.994-.9c.049-.265.127-.731.243-1.54a9.188,9.188,0,0,0,.057-1.445c-.454.1-.9.187-1.31.27.121.179.256.365.39.534a1.041,1.041,0,0,1,.2.9,5.7,5.7,0,0,1-2.358,3.341,6.21,6.21,0,0,1-2.521.752h0s-.01,0-.019.014a7.307,7.307,0,0,0,.575,1.471,16.643,16.643,0,0,0,1.686,2.716,2.669,2.669,0,0,1,.478-.806A18.781,18.781,0,0,1,847.868,607.486Z",
						transform: "translate(-836.494 -594.069)",
						fill: "none"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_334",
						"data-name": "Path 334",
						d: "M858.748,602.484c-.089.62-.157,1.1-.223,1.47.037.026.079.045.114.074h0a4.244,4.244,0,0,0,1.526.844,3.284,3.284,0,0,0,1.966-.25l.048-.107a9.319,9.319,0,0,1-.491-3.067c0-.48,0-1.143,0-1.862-.763.216-1.791.464-2.881.708A12.507,12.507,0,0,1,858.748,602.484Z",
						transform: "translate(-843.302 -593.007)",
						fill: "none"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_335",
						"data-name": "Path 335",
						d: "M839.009,608.69a1.042,1.042,0,0,1-.139-.967c.21-.585.378-1,.516-1.31A16.638,16.638,0,0,1,837.7,603.7a7.306,7.306,0,0,1-.575-1.471c.009-.012.016-.013.019-.013h0a6.211,6.211,0,0,0,2.521-.752,5.7,5.7,0,0,0,2.358-3.341,1.041,1.041,0,0,0-.2-.9c-.134-.168-.269-.355-.39-.534.414-.084.856-.175,1.31-.27-.017-.666-.073-1.4-.143-2.1-1.036.219-1.993.413-2.629.539a1.242,1.242,0,0,0-.64.35c-.19-.155-.385-.325-.588-.526-.916-.91-2.759-2.774-3.784-3.813a1.042,1.042,0,0,0-1.483,1.464c1.029,1.043,2.879,2.914,3.8,3.828a9.321,9.321,0,0,0,2.515,1.821l.042.11a3.29,3.29,0,0,1-1.213,1.567,4.187,4.187,0,0,1-1.677.482c-.046,0-.089.02-.134.028-.217-.31-.505-.7-.881-1.2a30.11,30.11,0,0,0-4.975-4.4,1.042,1.042,0,1,0-1.216,1.692,27.656,27.656,0,0,1,4.523,3.953c.49.654.764,1.038.916,1.261a2.1,2.1,0,0,0-.068,1.337,10.281,10.281,0,0,0,.725,1.818,18.9,18.9,0,0,0,1.9,3.06,6.206,6.206,0,0,0,.794,2.2,1.044,1.044,0,0,0,.782.585,3.111,3.111,0,0,0,.47.03,5.554,5.554,0,0,0,1.468-.212A5.355,5.355,0,0,1,839.009,608.69Z",
						transform: "translate(-829.307 -588.681)",
						fill: "#040505",
						opacity: .3
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_336",
						"data-name": "Path 336",
						d: "M872.113,589.914c.359-.295.7-.57.994-.807.12-.1.178-.066.213-.047.227.123.527.7.421,1.769-.206,2.085-2.315,4.866-3.078,5.729l-.415.426c.526.348,1.138.75,1.776,1.162l.165-.17c.135-.151,3.309-3.753,3.626-6.941.176-1.776-.384-3.2-1.5-3.8a2.245,2.245,0,0,0-2.508.247c-.3.242-.648.524-1.016.825-.631.518-1.416,1.16-2.168,1.727,0,.685-.01,1.624-.015,2.56A41.89,41.89,0,0,0,872.113,589.914Z",
						transform: "translate(-848.132 -586.956)",
						fill: "#040505",
						opacity: .3
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_337",
						"data-name": "Path 337",
						d: "M876.649,613.469a2.248,2.248,0,0,0-1.947-1.6c-.385-.044-.826-.088-1.3-.135a22.671,22.671,0,0,1-5.219-.875c-.847-.42-2.486-1.447-4-2.428-.26.267-.794.815-1.487,1.52,1.712,1.113,3.578,2.286,4.566,2.776,1.152.571,3.279.819,5.939,1.082.461.046.891.089,1.267.131.155.018.173.08.184.117.073.249-.12.865-.953,1.548-1.621,1.328-5.078,1.8-6.228,1.875-.1,0-9.51.134-12.439-.1a7.825,7.825,0,0,1-2.792,1.477,8.425,8.425,0,0,0,2.507.591c1.405.123,4.332.156,7.033.156,2.9,0,5.536-.038,5.767-.042.2-.012,4.994-.314,7.472-2.344C876.4,616.087,877.008,614.685,876.649,613.469Z",
						transform: "translate(-840.291 -597.243)",
						fill: "#040505"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_338",
						"data-name": "Path 338",
						d: "M856.266,591.626a1.042,1.042,0,1,0-2.056.336c.083.506.215,1.436.317,2.448.671-.142,1.373-.294,2.048-.447C856.441,592.708,856.28,591.711,856.266,591.626Z",
						transform: "translate(-841.228 -588.774)",
						fill: "#040505"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_339",
						"data-name": "Path 339",
						d: "M866.714,591.873a1.042,1.042,0,0,0-2.084-.013c0,.383-.006.847-.008,1.345a10.151,10.151,0,0,0,2.092-1.322Z",
						transform: "translate(-846.222 -588.809)",
						fill: "#040505"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_340",
						"data-name": "Path 340",
						d: "M850.66,610.5l.12-.1a1.048,1.048,0,0,0,.382-.741,15.557,15.557,0,0,1,.763-3.45,7.268,7.268,0,0,1,.635-1.447c.015,0,.02,0,.023,0a6.169,6.169,0,0,0,2.314,1.251,4.5,4.5,0,0,0,1.914.067c1.623-1.619,3.163-3.19,3.877-3.92l-.9-.6a1.24,1.24,0,0,0-.7-.2c-.024-.244-.042-.5-.043-.788,0-.685,0-1.742.006-2.8a6.91,6.91,0,0,1-1.457.756c-.18.06-.393.125-.631.193,0,.718,0,1.382,0,1.862a9.314,9.314,0,0,0,.491,3.067l-.049.107a3.284,3.284,0,0,1-1.966.249,4.242,4.242,0,0,1-1.526-.844h0c-.035-.029-.077-.048-.114-.074.066-.374.135-.849.224-1.47a12.516,12.516,0,0,0,.062-2.188c-.683.153-1.388.3-2.067.447a9.17,9.17,0,0,1-.057,1.445c-.116.809-.194,1.274-.243,1.54a2.1,2.1,0,0,0-.994.9,10.336,10.336,0,0,0-.773,1.8,18.781,18.781,0,0,0-.817,3.51,2.668,2.668,0,0,0-.478.806c.129.165.21.26.213.263a1.039,1.039,0,0,1,.255.8l-.016.153c.051.155.167.448.311.776a4.441,4.441,0,0,0,1.244-.369,3.917,3.917,0,0,1-.327-.222C850.462,610.93,850.586,610.64,850.66,610.5Zm1.4-7.84c-.023.015-.044.033-.066.049C852.02,602.688,852.041,602.671,852.064,602.656Zm-.158.123c-.006.006-.011.013-.017.019l-.005,0C851.891,602.792,851.9,602.786,851.906,602.779Z",
						transform: "translate(-838.573 -592.134)",
						fill: "#040505"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_341",
						"data-name": "Path 341",
						d: "M852.678,623.389a5.719,5.719,0,0,1-2.55-.779,4.442,4.442,0,0,1-1.244.369c-.143-.328-.26-.62-.311-.776l.016-.153a1.039,1.039,0,0,0-.255-.8s-.084-.1-.213-.263c-.138.306-.305.725-.516,1.31a1.042,1.042,0,0,0,.139.966,5.354,5.354,0,0,0,2.246,1.606,7.824,7.824,0,0,0,2.792-1.477Z",
						transform: "translate(-838.042 -603.259)",
						fill: "#040505"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_342",
						"data-name": "Path 342",
						d: "M864.311,610.121a6.473,6.473,0,0,0,2.116-.762,1.042,1.042,0,0,0,.5-.775c.024-.211.061-.439.1-.652.452.3.944.623,1.449.951.693-.7,1.227-1.253,1.487-1.52-.637-.413-1.25-.814-1.776-1.162C867.474,606.931,865.934,608.5,864.311,610.121Z",
						transform: "translate(-846.073 -596.174)",
						fill: "#040505"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_343",
						"data-name": "Path 343",
						d: "M857.04,599.016c-.03-.711-.091-1.44-.162-2.1-.675.153-1.377.305-2.048.447.07.7.126,1.434.143,2.1C855.652,599.321,856.357,599.169,857.04,599.016Z",
						transform: "translate(-841.532 -591.727)",
						fill: "#040505"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_344",
						"data-name": "Path 344",
						d: "M865.233,596.17a6.9,6.9,0,0,0,1.457-.756c0-.936.01-1.875.015-2.56a10.151,10.151,0,0,1-2.092,1.322c0,.7-.008,1.471-.01,2.186C864.839,596.295,865.053,596.23,865.233,596.17Z",
						transform: "translate(-846.213 -589.781)",
						fill: "#040505"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_345",
				"data-name": "Path 345",
				d: "M896.4,626.85h-3.126a1.042,1.042,0,1,0,0,2.084H896.4a1.042,1.042,0,0,0,0-2.084Z",
				transform: "translate(-841.612 -600.302)",
				fill: "#040505"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_346",
				"data-name": "Path 346",
				d: "M871.628,626.85H864a1.042,1.042,0,1,0,0,2.084h7.627a1.042,1.042,0,1,0,0-2.084Z",
				transform: "translate(-827.588 -600.302)",
				fill: "#040505"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_347",
				"data-name": "Path 347",
				d: "M846.489,626.85h-3.126a1.042,1.042,0,1,0,0,2.084h3.126a1.042,1.042,0,1,0,0-2.084Z",
				transform: "translate(-817.703 -600.302)",
				fill: "#040505"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgLoading);
export { ForwardRef as ReactComponent };
